module.exports = __webpack_public_path__ + "media/images/icon__close--rb-white@2x-61fe6be41c56ac1c0e16c01c74fa41d9.png";